export const MAXIMUM_CARD_DIMENSIONS = { width: 338, height: 450 }
export const RIGHT_COLUMN_WIDTH = 400
export const LEFT_COLUMN_EXPANDED_WIDTH = 310
export const LEFT_COLUMN_COLLAPSED_WIDTH = 75
